import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    faCheckCircle,
    faComment,
    faEdit,
    faInbox,
    faLock,
    faRotateForward,
    faRotateRight,
    faUnlock,
    faUserCheck,
    faUserXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Disclosure } from "@headlessui/react";
import moment from "moment-timezone";
import Avatar from "../../../../components/Avatar";
import { renderUserName } from "../../../../utils/helpers/user";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCompanyDateFormat, useCompanyTimeFormat } from "../../../../utils/hooks/company";

const HistoryContent = ({ plan, filters }) => {
    const { t } = useTranslation();

    const dateFormat = useCompanyDateFormat();

    const timeFormat = useCompanyTimeFormat();

    // useEffect(() => {
    //     const controller = new AbortController();
    //     if (planId) {
    //         const params = {
    //             plan: planId,
    //             year: filters.year,
    //             start: filters?.from && moment(filters.from).format("YYYY-MM-DD"),
    //             end: filters?.to && moment(filters.to).format("YYYY-MM-DD"),
    //             type: filters?.type,
    //         };
    //         const url = isSelf ? "/profile/time-off-history" : `/users/${user?.id}/time-off-history/`;

    //         getHistory(url, params, controller);
    //     }
    //     return () => controller.abort();
    // }, [getHistory, planId, isSelf, user?.id, filters.year, filters?.from, filters?.to, filters?.type]);

    const renderHistoryTypes = useCallback(
        (item) => {
            switch (item.type) {
                // case "approve-request": {
                //     return (
                //         <div>
                //             <FontAwesomeIcon icon={faCheckCircle} className="mr-1 mt-1 text-green" />
                //             {t("approved-request", {
                //                 user: renderUserName(item.user),
                //                 hours: -item.diff,
                //             })}{" "}
                //         </div>
                //     );
                // }
                // case "approve-cancel-request": {
                //     return (
                //         <>
                //             <FontAwesomeIcon icon={faCheckCircle} className="mr-2 text-green" />
                //             {t("approved-cancel-request", {
                //                 hours: Number(item.diff).toFixed(2),
                //             })}{" "}
                //         </>
                //     );
                // }
                case "assign": {
                    const assignMessage = t("assigned-this-plan", {
                        user: renderUserName(item.user),
                        hours: Number(item.diff.initial).toFixed(2),
                    });
                    return (
                        <>
                            <FontAwesomeIcon icon={faUserCheck} className="mr-2 text-green" />
                            <span dangerouslySetInnerHTML={{ __html: assignMessage }} />
                        </>
                    );
                }
                case "transfer": {
                    const transferMessage = t("transfer-this-plan", {
                        user: renderUserName(item.user),
                        hours: Number(item.diff.initial).toFixed(2),
                        plan: `${item.meta?.transferPlan?.timeoff?.code} (${item.meta?.transferPlan?.timeoff?.description})`,
                    });
                    return (
                        <>
                            <FontAwesomeIcon icon={faUserCheck} className="mr-2 text-green" />
                            <span dangerouslySetInnerHTML={{ __html: transferMessage }} />
                            {item.comment && <span className="text-muted"> - <FontAwesomeIcon icon={faComment} className="mr-2 text-default" />{item.comment}</span>}
                        </>
                    );
                }
                case "transfer-unassign": {
                    const transferUnassignMessage = t("transfer-unassign-this-plan", {
                        user: renderUserName(item.user),
                        hours: Number(item.meta?.transferToPlan?.plan?.bucket?.initial).toFixed(2),
                        plan: `${item.meta?.transferToPlan?.timeoff?.code} (${item.meta?.transferToPlan?.timeoff?.description})`,
                    });
                    return (
                        <>
                            <FontAwesomeIcon icon={faUserXmark} className="mr-2 text-danger" />
                            <span dangerouslySetInnerHTML={{ __html: transferUnassignMessage }} />
                            {item.comment && <span className="text-muted"> - <FontAwesomeIcon icon={faComment} className="mr-2 text-default" />{item.comment}</span>}
                        </>
                    );
                }
                case "unassign": {
                    const unassignMessage = t("unassigned-this-plan", {
                        user: renderUserName(item.user),
                        hours: Number(item.diff.updates).toFixed(2),
                    });
                    return (
                        <>
                            <FontAwesomeIcon icon={faUserXmark} className="mr-2 text-danger" />
                            <span dangerouslySetInnerHTML={{ __html: unassignMessage }} />
                        </>
                    );
                }
                case "lock-pay-group": {
                    let message;
                    if (Number(item.diff.earned) === 0 && Number(item.diff.lost) > 0) {
                        if (!!(item.payGroupItemStartDate && item.payGroupItemEndDate)) {
                            message = t("locked-pay-group-with-dates-lost", {
                                user: renderUserName(item.user),
                                payGroupCode: item.payGroupCode,
                                amount: Number(item.diff.earned).toFixed(2),
                                consumed: Number(item.diff.consumed).toFixed(2),
                                startDate: moment.parseZone(item.payGroupItemStartDate).format(dateFormat),
                                endDate: moment.parseZone(item.payGroupItemEndDate).format(dateFormat),
                            })
                        } else {
                            message = t("locked-pay-group-lost", {
                                user: renderUserName(item.user),
                                payGroupCode: item.payGroupCode,
                                amount: Number(item.diff.earned).toFixed(2),
                                consumed: Number(item.diff.consumed).toFixed(2),
                            })
                        }
                    } else if (!!(item.payGroupItemStartDate && item.payGroupItemEndDate)) {
                        message = t("locked-pay-group-with-dates", {
                            user: renderUserName(item.user),
                            payGroupCode: item.payGroupCode,
                            amount: Number(item.diff.earned).toFixed(2),
                            consumed: Number(item.diff.consumed).toFixed(2),
                            startDate: moment.parseZone(item.payGroupItemStartDate).format(dateFormat),
                            endDate: moment.parseZone(item.payGroupItemEndDate).format(dateFormat),
                        })
                    } else {
                        message = t("locked-pay-group", {
                            user: renderUserName(item.user),
                            payGroupCode: item.payGroupCode,
                            amount: Number(item.diff.earned).toFixed(2),
                            consumed: Number(item.diff.consumed).toFixed(2),
                        })
                    }
                    return (
                        <>
                            <FontAwesomeIcon icon={faLock} className="mr-1 mt-1" />
                            <span dangerouslySetInnerHTML={{ __html: message }} />
                        </>
                    );
                }
                case "unlock-pay-group": {
                    let message;
                    if (!!(item.payGroupItemStartDate && item.payGroupItemEndDate)) {
                        message = t("unlocked-pay-group-with-dates", {
                            user: renderUserName(item.user),
                            payGroupCode: item.payGroupCode,
                            amount: Number(item.diff.earned).toFixed(2),
                            startDate: moment.parseZone(item.payGroupItemStartDate).format(dateFormat),
                            endDate: moment.parseZone(item.payGroupItemEndDate).format(dateFormat),
                        })
                    } else {
                        message = t("unlocked-pay-group", {
                            user: renderUserName(item.user),
                            payGroupCode: item.payGroupCode,
                            amount: Number(item.diff.earned).toFixed(2),
                        })
                    }
                    return (
                        <>
                            <FontAwesomeIcon icon={faUnlock} className="mr-1 mt-1" />
                            <span dangerouslySetInnerHTML={{ __html: message }} />
                        </>
                    );
                }
                case "update-total": {
                    const updateMessage = t("updated-total", {
                        user: renderUserName(item.user),
                        added: t(item.diff.updates > 0 ? "added" : "removed"),
                        update: Number(Math.abs(item.diff.updates).toFixed(2)),
                        oldTotal: Number(item.old.total).toFixed(2),
                        newTotal: Number(item.new.total).toFixed(2),
                    });
                    return (
                        <>
                            <FontAwesomeIcon icon={faEdit} className="mr-2 text-orange" />
                            <span dangerouslySetInnerHTML={{ __html: updateMessage }} />
                            {item.comment && <span className="text-muted"> - <FontAwesomeIcon icon={faComment} className="mr-2 text-default" />{item.comment}</span>}
                        </>
                    );
                }
                case "regenerate-from-year-change": {
                    const regenerateMessage = t("regenerate-from-year-change", {
                        amount: Number(item.diff.initial).toFixed(2),
                    });
                    return (
                        <>
                            <FontAwesomeIcon icon={faRotateRight} className="mr-2 text-primary" />
                            <span dangerouslySetInnerHTML={{ __html: regenerateMessage }} />
                        </>
                    );
                }
                case "transfer-assign": {
                    return (
                        <>
                            {t("transfer-assign-message", {
                                user: renderUserName(item.user),
                                plan: item?.transfer?.plan?.code,
                                amount: item?.transfer?.total
                            })}
                        </>
                    )
                }
                case "transfer-unassign": {
                    return (
                        <>
                            {t("transfer-unassign-message", {
                                user: renderUserName(item.user),
                                plan: item?.transfer?.plan?.code,
                                amount: item?.transfer?.total
                            })}
                        </>
                    )
                }
                case "close-current-year": {
                    const closeMessage = t("close-current-year", {
                        amount: (-1 * item.diff.updates).toFixed(2),
                    });
                    return (
                        <>
                            <FontAwesomeIcon icon={faRotateForward} className="mr-1 mt-1" />
                            <span dangerouslySetInnerHTML={{ __html: closeMessage }} />
                        </>
                    );
                }
                case "update-from-integration": {
                    let message = t("update-from-integration", {
                        amount: Number(item.diff.earned).toFixed(2),
                        consumed: Number(item.diff.consumed).toFixed(2),
                    })
                    return (
                        <>
                            <FontAwesomeIcon icon={faLock} className="mr-1 mt-1" />
                            <span dangerouslySetInnerHTML={{ __html: message }} />
                        </>
                    );
                }
                default:
                    return null;
            }
        },
        [dateFormat, t]
    );

    return (
        <Disclosure.Panel key={plan.id} className="history-accordion-panel">
            { plan?.logs?.length > 0 ? (
                <div>
                    {plan?.logs?.map((item, i) => {
                        return (
                            <div key={i} className="d-flex gap-4 mb-1 border px-2 py-3 rounded shadow-sm">
                                {item?.type !== "regenerate-from-year-change" ? (
                                    <Avatar user={item.user} size={45} />
                                ) : null}
                                <div
                                    className={`d-flex flex-column pt-1 w-100 ${
                                        item?.type === "regenerate-from-year-change" && "ml-3"
                                    }`}
                                >
                                    <div className="d-flex gap-2">
                                        <span>{renderHistoryTypes(item)}</span>
                                    </div>
                                    <div className="d-flex gap-2 text-sm text-muted justify-content-end">
                                        <span>{moment.parseZone(item.date).local().format(dateFormat)}</span>
                                        <span>{moment.parseZone(item.date).local().format(timeFormat)}</span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="d-flex h-100 text-gray flex-column align-items-center justify-content-center">
                    <FontAwesomeIcon icon={faInbox} size="2xl" />
                    <span>{t("no-data")}</span>
                </div>
            )}
        </Disclosure.Panel>
    );
};

export default HistoryContent;
